import { DriverInvoiceBySepaTransferQueryInput } from '@allocab/allocab-driver-shared-types';
import { InvoiceV2Output } from '@allocab/allocab-invoice-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

export const TRANSACTION_INVOICES_LIMIT = 20;

type Input = Omit<DriverInvoiceBySepaTransferQueryInput, 'offset' | 'limit'> & { limit?: number };

const fetchTransactionInvoices = (input: DriverInvoiceBySepaTransferQueryInput) =>
  driverApi.get<DriverInvoiceBySepaTransferQueryInput, InvoiceV2Output, 'list'>(`/v2/invoice/by-sepa-transfer`, input);

export const useFetchTransactionInvoicesPage = (input: Input, pageNumber = 1) => {
  const limit = input.limit ?? TRANSACTION_INVOICES_LIMIT;
  const apiInput: DriverInvoiceBySepaTransferQueryInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  return useQuery(queryKeys.user.fetchTransactionInvoices(apiInput), () => fetchTransactionInvoices(apiInput), {
    keepPreviousData: true,
  });
};
